module.exports = __webpack_public_path__ + "img/google_logo.665eac25.svg";